import { AbstractPmsApiService } from "./abstract.service";
import { BillingInformation } from "../models";

/**
 * @class BillingInformationPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<BillingInformation>}
 */
export class BillingInformationPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/billing-information';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BillingInformation}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BillingInformation(attributes);
    }

    /**
     * @param {Property=} property
     * @param {Object=} params
     * @returns {Promise.<BillingInformation>}
     */
    get(property, params = {}) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {BillingInformation} billingInformation
     * @returns {Promise.<BillingInformation>}
     */
    save(property, billingInformation) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, billingInformation.toObjectExcept('property', 'country', 'city'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {BillingInformation} billingInformation
     * @param {String} language
     * @returns {Promise.<BillingInformation>}
     */
    sendEmailConfirmation(property, billingInformation, language) {

        const url = this.url({propertyId: property.id}),
            model = billingInformation.toObject('email_to_confirm');

        model.language = language;

        return this.http
            .post(url + '/email-confirmation', model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @returns {Promise.<boolean>}
     */
    removeEmailConfirmation(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .delete(url + '/email-confirmation', {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {Property} property
     * @param {string} hash
     * @returns {Promise.<boolean>}
     */
    checkConfirmationCode(property, hash) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url + '/check-confirmation-code', {hash: hash}, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {Property} property
     * @param {string} hash
     * @returns {Promise.<BillingInformation>}
     */
    confirmEmail(property, hash) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url + '/confirm-email', {hash: hash}, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/billing-information.service.js